import { render } from "./CancelMandateFail.vue?vue&type=template&id=ebe0ab24&scoped=true"
import script from "./CancelMandateFail.vue?vue&type=script&lang=js"
export * from "./CancelMandateFail.vue?vue&type=script&lang=js"

import "./CancelMandateFail.vue?vue&type=style&index=0&id=ebe0ab24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebe0ab24"]])

export default __exports__